import metaData from "../../../data/metaData";
import c from "../common";

export default {
  retry: c.retry.en,
  success: c.success.en,

  processing: c.processing.en,

  //functions
  BRerror: "BR file upload fail.",
  LogoError: "Logo file upload fail.",
  OtherError: "Other Photo(s) file Upload fail.",

  confirm: c.Confirm.en,

  cancel: c.cancel.en,
  add: c.add.en,

  //form start
  mustwrite: c.mustwrite.en,

  //function Button Opening Hour
  addNewTime: "add new opening hours",

  //IonHeader
  back: c.Back.en,
  editData: "Modify Data",
  clearDraft: "Clear Draft",

  //Step Title
  step1: "Basic",
  step2: "Address",
  step3: "Logo",
  step4: "Other Photo",
  step5: "Processing Approve",

  //step1
  ShopName: c.vendor.en.uppercase + " Name",

  Website: c.vendor.en.uppercase + " Website",
  ContactMain: c.vendor.en.uppercase + " Main Contact Number",

  OpeningHour: "Opening Hour",
  Section: "Section",

  intro: c.intro.en,
  within150: "Within 150 words",

  location: c.location.en,

  locationNull: "Not belong to any of the location",
  LT7: "Camel Paint Building",

  category: c.category.en,
  contactUsText:
    "(If the category of your Merchnat do not belong to any of the following, please contact us by email: " + metaData.offical.email.admin + ")",

  //step2
  shopAddress: "Shop address",
  switchOrder: "Edit",

  //step 3
  newLogo: "Add new Logo",
  switchLogo: "Switch Logo",
  limit1: "Upper Limit: Only 1 Logo is allowed",
  proportion: "Proportion: 1:1",

  //step 4
  newPhoto: "Add other photo(s)",
  limitReached: "The upper limit of 4 photos have been reached",
  switchOrDelete: "Switch Order / Delete",
  ConfirmPreview: "Confirm & Preview",

  limit4: "Upper Limit: 4 photos",
  proportion2: "Proportion: 16:9",

  drag: "Drag",
  photoToSwitch: "to switch the order",

  click: "Click",
  photoTodelete: "to delete the photo",

  //step 5
  ApplicationSubmitted: "Request Submitted",
  BackToFront: "OK",
  ApplicationNumber: "Request ID",
  haveBeenSubmitted: "have been submitted. We will process the approval procedure of your application.",
  FinalText: "The application is submitted. We will process the approval procedure of your application.",

  //Footer
  "Save&Next": "Save and Next",
  complete: c.complete.en,

  description_1: "Please select weekday",
  description_2: "Please select open hours",
};
